'use strict';

import execute_on from "../../../libs/execute-on";
import {getCsrfToken} from "../../../plugins/get-csrf-token";
import {swalErrorFire} from "../../../plugins/sweet-alert/sweet-alert-default";

execute_on('admin.survey.show', function () {
    $("#is_free").on('change', function () {
        const $checkbox = $(this);
        $.ajax({
            method: "PUT",
            headers: {'X-CSRF-TOKEN': getCsrfToken()},
            url: $checkbox.data('url'),
            data: {
                is_free: $checkbox.is(':checked')
            },
            complete: function(xhr) {
                if (202 !== xhr.status) {
                    swalErrorFire({
                        title: 'Survey free status could not be saved.',
                    });
                }
            }
        });
    });
    $("#is_captcha").on('change', function () {
        const $checkbox = $(this);
        $.ajax({
            method: "PUT",
            headers: {'X-CSRF-TOKEN': getCsrfToken()},
            url: $checkbox.data('url'),
            data: {
                is_captcha: $checkbox.is(':checked')
            },
            complete: function(xhr) {
                if (202 !== xhr.status) {
                    swalErrorFire({
                        title: 'Survey captcha status could not be saved.',
                    });
                }
            }
        });
    });
});
